/**
 * Code-owned English copy for the Workspace one-time task resume feedback.
 *
 * There is no CMS copy owner for these transient states yet; per the project
 * copy rules this module is the smallest owner until one exists. It must never
 * carry price, credit, or provider facts.
 */
export const siteRuntimeTaskPaymentResumeCopy = {
  submitted: 'Payment confirmed. Your task is running.',
  alreadySubmitted: 'Payment confirmed. Your task was already submitted.',
  needsLocalFiles:
    'Payment confirmed. Select your files again to start this task.',
  blockedFallback:
    'Payment was confirmed, but this task cannot start right now.',
  uploadRetry:
    'Your files were kept, but the upload did not finish. Refresh the page to retry.',
  requestFailed: 'Could not confirm the paid task. Refresh the page to retry.',
  pendingAvailable: 'Your purchased task is ready to continue.',
  continueTask: 'Continue task',
  selectFiles: 'Select files',
  fileCountMismatch: 'Select exactly {count} files for this task.',
  localStageFailed: 'The selected files could not be saved. Try again.',
} as const;
